import { NumberField } from "features/WorklistTools/shared/components/NumberField";
import { MethodSettingsProps } from "../shared";

export const PrePelletSplitTimer = ({
  twelve24TCInternalState,
  handleMethodSettingsChanged,
}: MethodSettingsProps) => {
  const value = twelve24TCInternalState.methodSettings.prePelletSplitTimer;
  const hasError = value === null || value === undefined;

  return (
    <NumberField
      size={"small"}
      id="pre-pellet-split-timer"
      label="Pre Pellet Split Timer (Minutes)"
      value={value}
      onChange={(rawValue) => {
        const parsedValue = rawValue === "" ? null : parseInt(rawValue, 10);
        handleMethodSettingsChanged("prePelletSplitTimer", parsedValue);
      }}
      minValue={0}
      maxValue={15}
      hasError={hasError}
      errorMessage={hasError ? "Value can't be undefined" : ""}
    />
  );
};
